import { combineReducers } from 'redux';
import getComments from './get-comments';
import newComment from './new-comment';
import deleteComment from './delete-comment';

const reducer = combineReducers({
  comments: getComments,
  newComment,
  deleteComment,
});

export default reducer;
